import {
  Dialog,
  DialogContent,
  DialogHeader,
} from '@/components/ui/dialog';

type SoldOutModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const SoldOutModal = ({ open, setOpen }: SoldOutModalProps) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-xs sm:max-w-md bg-white rounded-lg ">
        <DialogHeader />
        <div className="text-left">
          <p>選択頂いた商品が、売り切れてしまいました。</p>
          <p>再度、商品一覧から商品をお選び頂けますと幸いです。</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
